'use strict'

angular.module('internal.setup', ['ngAnimate', 'ui.bootstrap'])
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            // internal routings
            // setup tab
            .state('internal.setup.enterprise', {
                abstract: true,
                templateUrl: paths.app + 'setup/components/setup/setup.html',
                controller: 'InternalSetup',
                params: {
                }
            })
            // investigations
            .state('internal.setup.enterprise.investigations', {
                abstract: true,
                templateUrl: paths.app + 'setup/components/setup-integrations/setup-integrations.html',
                controller: 'InternalSetupIntegrations',
                params: {
                }
            })
            .state('internal.setup.enterprise.investigations.complaints', {
                url: '/setup/investigations/complaints',
                templateUrl: paths.app + 'setup/components/setup-react/setup-react.html',
                controller: 'InternalSetupReact',
                params: {
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.setup.enterprise.investigations.complaints").then(function (access) {
                            if (!access) {
                                $state.go('internal.setup.denied');
                            }
                        });
                    }]
                }
            })
            // integrations
            .state('internal.setup.enterprise.integrations', {
                abstract: true,
                templateUrl: paths.app + 'setup/components/setup-integrations/setup-integrations.html',
                controller: 'InternalSetupIntegrations',
                params: {
                }
            })
            .state('internal.setup.enterprise.integrations.eliteXchange', {
                url: '/setup/eliteXchange',
                templateUrl: paths.app + 'setup/components/setup-react/setup-react.html',
                controller: 'InternalSetupReact',
                params: {
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.setup.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.setup.enterprise.integrations.eliteXchangeDetails', {
                url: '/setup/eliteXchange/:id',
                templateUrl: paths.app + 'setup/components/setup-react/setup-react.html',
                controller: 'InternalSetupReact',
                params: {
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.setup.enterprise.integrations.eliteXchange").then(function (access) {
                            if (!access) {
                                $state.go('internal.setup.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.setup.enterprise.integrations.syncLog', {
                url: '/setup/sync/log',
                templateUrl: paths.app + 'setup/components/setup-react/setup-react.html',
                controller: 'InternalSetupReact',
                params: {
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.setup.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.setup.enterprise.integrations.syncLogDetails', {
                url: '/setup/sync/log/:id',
                templateUrl: paths.app + 'setup/components/setup-react/setup-react.html',
                controller: 'InternalSetupReact',
                params: {
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.setup.enterprise.integrations.syncLog").then(function (access) {
                            if (!access) {
                                $state.go('internal.setup.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.setup.enterprise.integrations.syncMapping', {
                url: '/setup/sync/mapping',
                templateUrl: paths.app + 'setup/components/setup-react/setup-react.html',
                controller: 'InternalSetupReact',
                params: {
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.setup.denied');
                            }
                        });
                    }]
                }
            })
            // Public Portal
            .state('internal.setup.enterprise.publicPortal', {
                abstract: true,
                templateUrl: paths.app + 'setup/components/setup-integrations/setup-publicPortal.html',
                controller: 'InternalSetupPublicPortal',
                params: {
                }
            })
            .state('internal.setup.enterprise.publicPortal.views', {
                url: '/setup/publicPortal/views',
                templateUrl: paths.app + 'setup/components/setup-react/setup-react.html',
                controller: 'InternalSetupReact',
                params: {
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.setup.enterprise.publicPortal.publicPortal").then(function (access) {
                            if (!access) {
                                $state.go('internal.setup.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.setup.enterprise.publicPortal.viewsPage', {
                url: '/setup/publicPortal/views/:id',
                templateUrl: paths.app + 'setup/components/setup-react/setup-react.html',
                controller: 'InternalSetupReact',
                params: {
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.setup.enterprise.publicPortal.publicPortal").then(function (access) {
                            if (!access) {
                                $state.go('internal.setup.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.setup.enterprise.publicPortal.viewsCriteria', {
                url: '/setup/publicPortal/views/:id/criteria',
                templateUrl: paths.app + 'setup/components/setup-react/setup-react.html',
                controller: 'InternalSetupReact',
                params: {
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.setup.enterprise.publicPortal.publicPortal").then(function (access) {
                            if (!access) {
                                $state.go('internal.setup.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.setup.enterprise.publicPortal.viewsPermission', {
                url: '/setup/publicPortal/views/:id/permission',
                templateUrl: paths.app + 'setup/components/setup-react/setup-react.html',
                controller: 'InternalSetupReact',
                params: {
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.setup.enterprise.publicPortal.publicPortal").then(function (access) {
                            if (!access) {
                                $state.go('internal.setup.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.setup.enterprise.publicPortal.viewsPreview', {
                url: '/setup/publicPortal/views/:id/preview',
                templateUrl: paths.app + 'setup/components/setup-react/setup-react.html',
                controller: 'InternalSetupReact',
                params: {
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view("internal.setup.enterprise.publicPortal.publicPortal").then(function (access) {
                            if (!access) {
                                $state.go('internal.setup.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.setup.enterprise.publicPortal.vehicleLookup', {
                url: '/setup/publicPortal/vehicleLookup',
                templateUrl: paths.app + 'setup/components/setup-react/setup-react.html',
                controller: 'InternalSetupReact',
                params: {
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.setup.denied');
                            }
                        });
                    }]
                }
            })
    }])
;